<template>
  <div>
    <header>
      <!-- Navbar -->
      <nav class="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
        <div class="container px-5">
          <a class="navbar-brand" href="#page-top">
            <img
              src="./assets/img/logo-rmbg-sm.png"
              class="d-block"
              alt="1"
              width="60px"
          /></a>
          <div class="mobile-display">
            <Slide right>
              <a id="home" :href="registerHref">
                <span>สมัครสมาชิก</span>
              </a>
              <a id="home" :href="loginHref"> <span>เข้าสู่ระบบ</span> </a>
            </Slide>
          </div>

          <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav ms-auto">
              <li class="nav-item">
                <a class="link-in p-2 m-2" :href="registerHref">
                  สมัครสมาชิก
                </a>
              </li>
              <li class="nav-item">
                <a class="link-in p-2" :href="loginHref">
                  เข้าสู่ระบบ
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <!-- Navbar -->
    </header>

    <div class="-outer-wrapper">
      <div class="-left-wrapper">
        <span class="-item-wrapper"
          ><span class="-ic-img">
            <a :href="loginHref">
              <img
                loading="lazy"
                width="400"
                height="448"
                src="./assets/img/icon/3.png"
                class="image wp-image-1579 attachment-full size-full"
                alt=""
                style="max-width: 100%; height: auto"
                decoding="async"/></a></span></span
        ><span class="-item-wrapper"
          ><span class="-ic-img"
            ><a :href="registerHref"
              ><img
                loading="lazy"
                width="400"
                height="448"
                src="./assets/img/icon/4.png"
                class="image wp-image-1580 attachment-full size-full"
                alt=""
                style="max-width: 100%; height: auto"
                decoding="async"/></a></span
        ></span>
      </div>
      <span
        class="-center-wrapper js-footer-lobby-selector js-menu-mobile-container"
      >
        <div class="-selected">
          <a :href="loginHref"
            ><img
              loading="lazy"
              width="400"
              height="400"
              src="./assets/img/logo-rmbg-sm.png"
              class="image wp-image-1571 attachment-full size-full"
              alt=""
              style="max-width: 100%; height: auto"
              decoding="async"
              sizes="(max-width: 400px) 100vw, 400px"
          /></a>
        </div>
      </span>
      <div class="-fake-center-bg-wrapper">
        <svg viewBox="-10 -1 30 12">
          <defs>
            <linearGradient
              id="rectangleGradient"
              x1="0%"
              y1="0%"
              x2="0%"
              y2="100%"
            >
              <stop offset="0%" stop-color="#4695fc"></stop>
              <stop offset="100%" stop-color="#081e99"></stop>
            </linearGradient>
          </defs>
          <path
            d="M-10 -1 H30 V12 H-10z M 5 5 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0z"
          ></path>
        </svg>
      </div>
      <div class="-right-wrapper">
        <span class="-item-wrapper"
          ><span class="-ic-img"
            ><a href="#"
              ><img
                loading="lazy"
                width="400"
                height="448"
                src="./assets/img/icon/5.png"
                class="image wp-image-1577 attachment-full size-full"
                alt=""
                style="max-width: 100%; height: auto"
                decoding="async"
                sizes="(max-width: 400px) 100vw, 400px"/></a></span></span
        ><span class="-item-wrapper"
          ><span class="-ic-img"
            ><a :href="lineHref"
              ><img
                loading="lazy"
                width="400"
                height="448"
                src="./assets/img/icon/6.png"
                class="image wp-image-1578 attachment-full size-full"
                alt=""
                style="max-width: 100%; height: auto"
                decoding="async"
                sizes="(max-width: 400px) 100vw, 400px"/></a></span
        ></span>
      </div>
      <div class="-fully-overlay js-footer-lobby-overlay"></div>
    </div>
  </div>
</template>

<script>
import { Slide } from "vue-burger-menu"; // import the CSS transitions you wish to use, in this case we are using `Slide`

import "bootstrap/dist/css/bootstrap.min.css";
export default {
  components: { Slide },
  computed: {
    loginHref: function() {
      return process.env.VUE_APP_LOGIN_HREF;
    },
    registerHref: function() {
      return process.env.VUE_APP_REGISTER_HREF;
    },
    lineHref: function() {
      return process.env.VUE_APP_LINE_HREF;
    },
  },
  name: "app",
  data() {
    return {};
  },
  props: {},

  methods: {},
};
</script>
<style>
.bm-burger-button {
  top: 15px !important;
}
.bm-burger-bars {
  background-color: rgb(255, 216, 89) !important;
}

.page .entry-title {
  display: none;
}
a {
  background-color: transparent;
  text-decoration: none;
  color: #00a715;
}
.entry-title {
  color: #ffffff;
}
.page-content {
  color: #ffffff;
}
.line-contact {
  @apply p-1 text-white transition
        duration-500
        ease-in-out
        transform
        hover:-translate-y-1 hover:scale-110;
  border-radius: 50%;
  background: linear-gradient(#ca9541, #f8d88b, #ca9541);
  display: flex;
  position: fixed;
  right: 12px;
  top: 240px;
  z-index: 10;
}

.mobile-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  justify-content: space-around;
  z-index: 100000000;
  display: none;
}
.bloc-icon {
  justify-content: center;
  align-items: center;
}
.bloc-icon img {
  width: 100px;
}
.bloc-icon-main img {
  width: 120px;
  top: 10px;
}

.-outer-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  justify-content: space-around;
  z-index: 100000000;
  display: none;
  align-items: flex-end;
}
.-left-wrapper {
  border-top-left-radius: 10px;
  border-top-right-radius: 22px;

  display: flex;
  align-items: flex-end;
  flex: 1;
  z-index: 2;
  height: 70px;
  padding-bottom: 6px;
  background: linear-gradient(#3f4045, #222127) !important;
  border-top: 3px solid #f9db48 !important;
  height: 60px !important;
  border-top: 3px solid #fff9f1;
  transition: -webkit-filter 0.2s;
  transition: filter 0.2s;
  transition: filter 0.2s, -webkit-filter 0.2s;
}
.-item-wrapper {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  color: #fff;
  position: relative;
}
.-ic-img {
  max-width: 100%;
  height: auto;
  padding-bottom: 0px !important;
  width: 48px !important;
}
.-center-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  z-index: 4;
  width: 80px;
  height: 80px;
  margin: 0 8px 16px;
  padding-bottom: 2px;
  color: #fff;
  border-radius: 50%;
  background: radial-gradient(
    100% 100% at 50% 0,
    #2f8dba 0,
    #1036bc 44%,
    #1835d9 100%
  );
  border: 2px solid #2451ee;
  background: radial-gradient(
    100% 100% at 50% 0,
    #3f4045 0,
    #3f4045 44%,
    #222127 100%
  ) !important;
  border: 2px solid #222127 !important;
}
.-selected {
  transition: all 0.4s;
  background-size: 450px;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  background-position: 0 0;
  border-radius: 50%;
  display: flex;
  /*     flex-direction: column; */
  justify-content: flex-end;
  align-items: center;
  text-align: center;
}
.-fake-center-bg-wrapper {
  position: absolute;
  left: 0;

  z-index: 1;
  width: 100%;
  height: 50px;
  transition: -webkit-filter 0.2s;
  transition: filter 0.2s;
  transition: filter 0.2s, -webkit-filter 0.2s;
  overflow: hidden;
}

svg {
  position: absolute;
  left: 50%;
  bottom: 0;
  height: 108px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  overflow: hidden;
  vertical-align: middle;
  fill: url(#rectangleGradient);
}
#rectangleGradient > stop {
  stop-color: #3f4045 !important;
}
#rectangleGradient > stop:last-child {
  stop-color: #222127 !important;
}
.-right-wrapper {
  display: flex;
  align-items: flex-end;
  flex: 1;
  z-index: 2;
  height: 70px;
  padding-bottom: 6px;
  background: linear-gradient(#4695fc, #081e99);

  transition: -webkit-filter 0.2s;
  transition: filter 0.2s;
  transition: filter 0.2s, -webkit-filter 0.2s;
  background: linear-gradient(#3f4045, #222127) !important;
  border-top: 3px solid #f9db48 !important;
  height: 60px !important;
  border-top-right-radius: 10px;
  border-top-left-radius: 22px;
}
.-fully-overlay js-footer-lobby-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6);
}

@media screen and (max-width: 769px) {
  .mobile-nav {
    display: flex;
  }
  .-outer-wrapper {
    display: flex;
  }
}
</style>
